import { Component } from 'react';
import PersonnelRow from './personnel-row';
import PersonnelForm from './personnel-form';
import Filter from './filter';

import './personnel-list.css';

let queryTimeout = null;

class PersonnelList extends Component {
  constructor(props) {
    super(props);

    this.FORM_MODES = {
      ADD: 1,
      EDIT: 2,
    };

    this.state = {
      filter: '',
      page: 1,
      show_personnel_form: false,
      editing_personnel_info: false,
      clear: false,
      form_mode: this.FORM_MODES.ADD,
      edit_personnel_id: -1,
      edit_personnel_name: '',
    };
  }

  updatePage(newPage) {
    this.props.update_page(newPage);
    this.setState({ page: newPage });
  }

  updateFilter(newFilter) {
    const { update_query } = this.props;

    if (queryTimeout) {
      clearTimeout(queryTimeout);
    }

    queryTimeout = setTimeout(() => {
      newFilter = newFilter.toLowerCase();
      update_query(newFilter);
      this.setState({ filter: newFilter });
    }, 1000);
  }

  startEdit(personnelInfo) {
    this.setState({
      editing_personnel_info: personnelInfo,
      show_personnel_form: true,
      form_mode: this.FORM_MODES.EDIT,
      edit_personnel_id: personnelInfo.id,
      edit_personnel_name: personnelInfo.first_name + ' ' + personnelInfo.last_name,
      locked_out: personnelInfo.lockout,
    });
  }

  async addPersonnel(personnelData) {
    const { add_personnel } = this.props;
    await add_personnel(personnelData);
  }

  async editPersonnel(editData) {
    const { edit_personnel } = this.props;
    const { edit_personnel_id } = this.state;
    await edit_personnel(edit_personnel_id, editData);
  }

  showPersonnelForm() {
    this.setState({
      show_personnel_form: true,
      form_mode: this.FORM_MODES.ADD,
    });
  }

  hidePersonnelForm() {
    const { personnel_form_hidden } = this.props;

    this.setState({
      show_personnel_form: false,
      clear: true,
      form_mode: this.FORM_MODES.ADD,
    });

    personnel_form_hidden();
  }

  checkUserOrganizationFilter(selectedOrganizations, userOrganizationNames) {
    for (const index in selectedOrganizations) {
      const currentOrganization = selectedOrganizations[index];
      if (userOrganizationNames.indexOf(currentOrganization.name) > -1) {
        return true;
      }
    }
    return false;
  }

  printPersonnel() {
    const { personnel_data, selected_organizations } = this.props;
    const { filter } = this.state;

    return personnel_data.map((personnel) => {
      let personnelName = personnel.first_name + ' ' + personnel.last_name;
      personnelName = personnelName.toLowerCase();
      const email = personnel.email ? personnel.email.toLowerCase() : '';
      const role = personnel.role.name.toLowerCase();
      const userOrganizationNames = personnel.organizations.organization_names;
      const personnelID = personnel.id;

      if (filter === '' || personnelName.includes(filter) || email.includes(filter) || role.includes(filter)) {
        if (selected_organizations.length > 0) {
          if (this.checkUserOrganizationFilter(selected_organizations, userOrganizationNames)) {
            return (
              <PersonnelRow
                key={personnelID}
                personnel_data={personnel}
                start_edit={this.startEdit.bind(this)}
                set_personnel_lockout_status={this.setPersonnelLockoutStatus.bind(this)}
              />
            );
          }
          return '';
        } else {
          return (
            <PersonnelRow
              key={personnelID}
              personnel_data={personnel}
              start_edit={this.startEdit.bind(this)}
              set_personnel_lockout_status={this.setPersonnelLockoutStatus.bind(this)}
            />
          );
        }
      } else {
        return '';
      }
    });
  }

  async setPersonnelLockoutStatus(personnelID, newStatus) {
    const { set_personnel_lockout } = this.props;
    await set_personnel_lockout(personnelID, newStatus);
  }

  archiveDone(personnelID) {
    const { archive_done } = this.props;
    archive_done(personnelID);
  }

  render() {
    const { organizations, roles, errors, should_hide_form, total_pages, loading } = this.props;
    const {
      show_personnel_form,
      clear,
      editing_personnel_info,
      form_mode,
      edit_personnel_id,
      edit_personnel_name,
      page,
    } = this.state;
    let set = false;
    let shouldClear = false;

    if (clear) {
      shouldClear = clear;
      this.setState({ clear: false });
    }

    if (should_hide_form) {
      this.hidePersonnelForm();
    }

    if (editing_personnel_info) {
      set = {
        first_name: editing_personnel_info.first_name,
        last_name: editing_personnel_info.last_name,
        email: editing_personnel_info.email,
        role: editing_personnel_info.role.id.toString(),
        organizations: editing_personnel_info.organizations.organizations,
        send_usage_email: editing_personnel_info.send_usage_email,
      };
      this.setState({ editing_personnel_info: false });
    }

    const editPersonnelData = {
      id: edit_personnel_id,
      name: edit_personnel_name,
    };

    return (
      <div className="personnel_list">
        <div className="personnel_list_title">Manage Personnel</div>
        <PersonnelForm
          hide_func={this.hidePersonnelForm.bind(this)}
          show={show_personnel_form}
          mode={form_mode}
          set={set}
          clear={shouldClear}
          organizations={organizations}
          roles={roles}
          add_personnel={this.addPersonnel.bind(this)}
          edit_personnel={this.editPersonnel.bind(this)}
          errors={errors}
          edit_personnel_data={editPersonnelData}
          archive_done={this.archiveDone.bind(this)}
        />
        <Filter update_filter={this.updateFilter.bind(this)} />
        <button className="personnel_list_add_personnel" onClick={this.showPersonnelForm.bind(this)}>
          Add Personnel
        </button>
        {!loading && (
          <table className="personnel_table">
            <thead>
              <tr className="personnel_table_row">
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Facility</th>
                <th>Send Data Usage Email</th>
                <th></th>
              </tr>
            </thead>
            <tbody>{this.printPersonnel()}</tbody>
          </table>
        )}
        {loading && <div className="personnel_list_loading">Loading...</div>}
        <div className="personnel_list_pagination">
          {page > 1 && (
            <button
              className="pagination_button"
              onClick={() => {
                if (this.state.page > 1) {
                  this.updatePage(this.state.page - 1);
                }
              }}
            >
              Previous
            </button>
          )}
          {page < total_pages && (
            <button
              className="pagination_button"
              onClick={() => {
                const { total_pages } = this.props;
                if (this.state.page < total_pages) {
                  this.updatePage(this.state.page + 1);
                }
              }}
            >
              Next
            </button>
          )}

          <div className="personnel_list_pagination_page">
            Page {page} of {total_pages}
          </div>
        </div>
      </div>
    );
  }
}

export default PersonnelList;
